export const faqs = [
  [
    'Is this a physical product?',
    'No. Complete Professional Myofascial Release Bundle is a 100% digital product. You receive electronic access to the complete collection.',
  ],
  [
    'Who is this system designed for?',
    'Physiotherapists, physical therapists, qualified manual therapists, massage professionals working within their scope, and rehabilitation specialists.',
  ],
  [
    'Do I need previous manual therapy training?',
    'Yes. This is a professional reference collection. It does not replace anatomy education, supervised clinical training, or licensing requirements.',
  ],
  [
    'Are step-by-step techniques included?',
    'Yes. 60 soft-tissue techniques organized by region, with patient positioning, hand placement, contact direction, execution, and precautions.',
  ],
  [
    'Are complete rehabilitation sessions included?',
    'Yes. 40 clinical session templates with functional objectives, manual therapy references, exercises, timing, and reassessment.',
  ],
  ['Are the five bonuses included?', 'Yes. All five professional bonuses are included at no additional charge.'],
  [
    'How do I receive the product?',
    'After completing your purchase, you receive instructions to access and download your digital materials.',
  ],
  ['Is this a subscription?', 'No. It is a one-time payment of $26.90 USD, with no recurring charges.'],
  [
    'Does this replace professional training or medical care?',
    'No. It is intended for professional educational and reference purposes and does not replace qualifications, diagnosis, or medical care.',
  ],
  ['Is there a guarantee?', 'Yes. Your purchase is covered by a 7-day guarantee, subject to the applicable refund terms.'],
] as const
